// extracted by mini-css-extract-plugin
var _1 = "styles-module__ebscoLogo___pXSij";
var _2 = "styles-module__ebscoLogo__mobile___WYFVy";
var _3 = "styles-module__footer___zM2IF";
var _4 = "styles-module__header___m3udZ";
var _5 = "styles-module__logoWrapper___RLp9a";
var _6 = "styles-module__mainContent___HJMkF";
var _7 = "styles-module__mainContentWrapper___pmGwf";
var _8 = "styles-module__page___Gstgx";
export { _1 as "ebscoLogo", _2 as "ebscoLogo__mobile", _3 as "footer", _4 as "header", _5 as "logoWrapper", _6 as "mainContent", _7 as "mainContentWrapper", _8 as "page" }
